import { useUpdateRecipientGroup as useUpdateRecipientGroupApi } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import type { UpdateRecipientGroupRequestType } from 'src/api/generated/touring/types';

const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.UPDATE_RECIPIENT_GROUP';

type UseUpdateRecipientGroupReturnType = {
  // Resolves to true on success so the caller only closes the modal then.
  updateRecipientGroup: (
    groupId: string,
    data: UpdateRecipientGroupRequestType
  ) => Promise<boolean>;
};

// Groups and mailings refetch is triggered by the generated mutation (see orval.config.ts).
export const useUpdateRecipientGroup =
  (): UseUpdateRecipientGroupReturnType => {
    const { showSuccess, showError } = useNotification();
    const { mutateAsync } = useUpdateRecipientGroupApi<AxiosError>();

    const updateRecipientGroup = async (
      groupId: string,
      data: UpdateRecipientGroupRequestType
    ) => {
      try {
        await mutateAsync({ groupId, data });
      } catch (error) {
        showError({
          title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
          message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
          error: error as AxiosError,
        });
        return false;
      }

      showSuccess({
        title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
        message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
      });
      return true;
    };

    return { updateRecipientGroup };
  };
